import { useCallback, useMemo } from "react"

import { logger } from "../logger"
import { toKnownError } from "../utils/error/error"

const userVisibleErrorLogger = logger.withScope("user-visible-error")

/*
 * Logs user-visible errors displayed in informational components.
 * Use error() for unexpected errors, info() for expected.
 */
export function useUserVisibleErrorLogger(scope?: string) {
  const chainedLogger = useMemo(
    () =>
      scope ? userVisibleErrorLogger.withScope(scope) : userVisibleErrorLogger,
    [scope]
  )

  const error = useCallback(
    (error: unknown, userMessage: string) => {
      if (!error) return

      const knownError = toKnownError(error)

      chainedLogger.error(knownError.message, { userMessage }, knownError)
    },
    [chainedLogger]
  )

  const info = useCallback(
    (message: string, userMessage: string) => {
      chainedLogger.info(message, { userMessage })
    },
    [chainedLogger]
  )

  return { error, info }
}
